import { Switch } from 'react-router-dom'
import AccountancySoftwareList from './AccountancySoftwareList'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_TROUBLESHOOT } from 'app-support/permissions/Permissions'
import { accountancySoftwareRoute } from 'routes/routeNames'

const enhance = withRegionSwitchHandler('/troubleshoot')

const AccountancySoftwareContainer = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_TROUBLESHOOT} exact path={accountancySoftwareRoute} component={AccountancySoftwareList} />
  </Switch>
)

export default enhance(AccountancySoftwareContainer)
